/* eslint-disable dot-notation */
/* eslint-disable @typescript-eslint/no-shadow */
import LanguageSelectorItem from 'components/LanguageSelectorItem'
import { useEffect, useMemo, useRef, useState } from 'react'
import styled from 'styled-components'
import { LOCALIZATION_LIST, CURRENCY_LIST } from 'config/constants'
import { useDispatch } from 'react-redux'
import { setCurrency } from 'state/app/actions'

const WrapSelector = styled.div`
  .language-selector {
    position: relative;
  }
  #selected-country-btn {
    padding: 0;
    border: 1px solid #000;
    background: transparent;
    border-radius: 30px;
  }

  ul {
    overflow: hidden;
    width: 210px;

    &:-webkit-scrollbar {
      display: none;
    }
  }
  .language-item-hover {
    display: flex;
    align-items: center;
    padding: 6px;
    background-color: white;
    color: #bbbbbb;
    border-radius: 32px;
    gap: 6px;
    margin-left: 8px;
    cursor: pointer;
    font-weight: bold;
    border: 1px solid;
    p {
      display: none;
    }
    img {
      width: 25px;
    }
    .active {
      display: block;
    }
  }
  .language-item-hover:hover {
    p {
      display: block;
    }
  }
  @media (max-width: 1024px) {
    .language-selector {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }
`

const useCloseOnOutsideClick = (ref, setIsSelected) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsSelected(false)
      }
    }
    const handleDocumentClick = (event) => handleClickOutside(event)
    document.addEventListener('click', handleDocumentClick)

    return () => {
      document.removeEventListener('click', handleDocumentClick)
    }
  }, [ref, setIsSelected])
}

const LanguageSelector = ({ ...props }) => {
  const dispatch = useDispatch()
  const [isSelected, setIsSelected] = useState<boolean>(false)
  const [isTypeLanguage, setIsTypeLanguage] = useState<string>('EN')
  const [isTypeCurrency, setIsTypeCurrency] = useState<string>('USD')
  const [isHovered, setIsHovered] = useState<boolean>(false)

  const buttonRef = useRef(null)

  useMemo(() => {
    const cacheLocalize = localStorage.getItem('localize')
    let _flag = LOCALIZATION_LIST[0].flag
    if (cacheLocalize) {
      const jsonLocalize = JSON.parse(cacheLocalize)
      _flag = jsonLocalize ? jsonLocalize.flag : LOCALIZATION_LIST[0].flag
    }
    setIsTypeLanguage(_flag)
  }, [])

  useEffect(() => {
    if (localStorage.getItem('currency')) {
      setIsTypeCurrency(localStorage.getItem('currency'))
      dispatch(setCurrency(localStorage.getItem('currency')))
    } else {
      setIsTypeCurrency(CURRENCY_LIST[0].flag)
    }
  }, [dispatch])

  useCloseOnOutsideClick(buttonRef, setIsSelected)
  return (
    <WrapSelector>
      <div className="language-selector">
        <button
          type="button"
          className="language-item-hover"
          onClick={() => setIsSelected(!isSelected)}
          ref={buttonRef}
        >
          <img src="/images/icons/earth.png" alt="icon-earth" />
          <p className={(isSelected || isHovered) && 'active'}>
            {isTypeLanguage} - {isTypeCurrency}
          </p>
        </button>
        {(isSelected || isHovered) && (
          <LanguageSelectorItem
            isTypeLanguage={isTypeLanguage}
            setIsTypeLanguage={setIsTypeLanguage}
            isTypeCurrency={isTypeCurrency}
            setIsHovered={setIsHovered}
            setIsTypeCurrency={setIsTypeCurrency}
          />
        )}
      </div>
    </WrapSelector>
  )
}

export default LanguageSelector
